import { useState } from 'react';
import { Button, useToast } from '@morressier/alembic';
import { removeDraftSubmission } from 'src/api/mutations';
import { useFormContext } from '../../../../../contexts/FormContext';
import BackToUploadDeleteModal from './BackToUploadDeleteModal';

interface Props {
  submissionId: string;
  submissionContextId: string;
  isDisabled?: boolean;
  goToFirstStep: () => void;
}

const BackToUpload: React.FC<Props> = ({
  submissionId,
  submissionContextId,
  isDisabled,
  goToFirstStep
}) => {
  const toast = useToast();
  const { resetFormData } = useFormContext();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const removeDraftMutation = removeDraftSubmission();

  const onDeleteDraft = async () => {
    const res = await removeDraftMutation.mutateAsync({
      submissionContextId,
      submissionId
    });
    if (res && res.isSuccess) {
      setIsOpen(false);
      resetFormData();

      return goToFirstStep();
    }

    return toast({
      variant: 'error',
      title: 'Replace manuscript Unsuccessful',
      description:
        'We encountered an issue while deleting your draft submission. Please try again.',
      isClosable: true
    });
  };

  return (
    <>
      <Button
        variant="secondary"
        onClick={() => setIsOpen(true)}
        isDisabled={isDisabled}
      >
        Back to Upload
      </Button>

      <BackToUploadDeleteModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onRemove={onDeleteDraft}
        isLoading={removeDraftMutation.isLoading}
      />
    </>
  );
};

export default BackToUpload;
